import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import { Box, Typography, Paper } from '@mui/material'
import { makeStyles } from '@material-ui/core'

const SuggestionList = forwardRef((props, ref) => {
  const classes = useStyles()
  const [selectedIndex, setSelectedIndex] = useState(0)

  const selectItem = (index) => {
    const item = props.items[index]
    if (item) {
      props.command(item)
    }
  }

  const upHandler = () => {
    setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length)
  }

  const downHandler = () => {
    setSelectedIndex((selectedIndex + 1) % props.items.length)
  }

  const enterHandler = () => {
    selectItem(selectedIndex)
  }

  useEffect(() => setSelectedIndex(0), [props.items])

  useImperativeHandle(ref, () => ({
    onKeyDown: ({ event }) => {
      if (event.key === 'ArrowUp') {
        upHandler()
        return true
      }

      if (event.key === 'ArrowDown') {
        downHandler()
        return true
      }

      if (event.key === 'Enter') {
        enterHandler()
        return true
      }

      return false
    }
  }))

  return (
    <Paper className={classes.suggestionDropdown} elevation={8}>
      {props.items.length ? (
        props.items.map((item, index) => (
          <Box
            key={index}
            className={`${classes.suggestionItem} ${
              index === selectedIndex ? classes.selected : ''
            }`}
            onClick={() => selectItem(index)}
            component="button">
            <Box className={classes.placeholderIcon}>@@</Box>
            <Box className={classes.itemContent}>
              <Typography variant="body2" className={classes.itemLabel}>
                {item.label}
              </Typography>
              <Typography variant="caption" className={classes.itemDescription}>
                {item.description}
              </Typography>
            </Box>
          </Box>
        ))
      ) : (
        <Box className={classes.suggestionItem}>
          <Typography variant="body2">No results</Typography>
        </Box>
      )}
    </Paper>
  )
})

SuggestionList.displayName = 'SuggestionList'

const useStyles = makeStyles(() => ({
  suggestionDropdown: {
    minWidth: '280px',
    maxWidth: '320px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    border: '1px solid #e0e0e0',
    borderRadius: '8px'
  },
  suggestionItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    cursor: 'pointer',
    border: 'none',
    width: '100%',
    textAlign: 'left',
    background: 'transparent',
    transition: 'background-color 0.2s',
    gap: '12px',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  selected: {
    backgroundColor: '#f0f7ff !important',
    borderLeft: '3px solid #1976d2'
  },
  placeholderIcon: {
    color: '#1976d2',
    fontWeight: 'bold',
    fontSize: '12px',
    flexShrink: 0
  },
  itemContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flex: 1
  },
  itemLabel: {
    fontWeight: '500',
    color: '#333'
  },
  itemDescription: {
    color: '#666',
    lineHeight: 1.2
  }
}))

export default SuggestionList
